import { PlayIcon } from "@octopusdeploy/design-system-icons";
import cn from "classnames";
import * as React from "react";
import type { ExternalLinkProps } from "./ExternalLink";
import ExternalLink from "./ExternalLink";
import styles from "./style.module.less";
interface ExternalVideoLinkProps extends ExternalLinkProps {
    children: React.ReactNode;
}
const ExternalVideoLink = ({ className, children, ...rest }: ExternalVideoLinkProps) => (<ExternalLink className={cn([styles.externalVideoLink, className])} trackAnalytics={true} {...rest}>
        <PlayIcon size={20}/>
        {children}
    </ExternalLink>);
export default ExternalVideoLink;
